export class MovementDomainFintoc {
  static TRANSFER: string = "transfer";
  static OTHER: string = "other";
  static CHECK: string = "check";
}